<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ resellerProduct.name }} - {{ $t("COMMON.GALLERY") }}
      </span>
    </div>

    <div class="row" style="">
      <div
        class="col-4"
        v-for="(image, key) in resellerProduct.gallery"
        :key="key"
      >
        <img :src="image" class="argon-image mb-2" style="width: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "reseller-product-view-gallery",

  components: {},

  props: ["resellerProduct"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    resellerProduct(resellerProduct) {},
  },
};
</script>
